var indentStyle = {"indentZero":"_8x74a","indentOne":"EfGzj","indentTwo":"o44IT","indentThree":"_9Amtt","indentFour":"a5s3f","indentFive":"dobRw","indentSix":"WH89k"};

export { indentStyle as i };
//# sourceMappingURL=indentation-0feb4ba4.js.map
